const uploadEmptyFileErrorModalSupport = {
  label: 'Necessário selecionar o arquivo'
};

export default uploadEmptyFileErrorModalSupport;
